import { type ClientConfig } from 'config/clients';
import { isStandalone } from 'utils/environment';

type CustomWindow = Window & {
  __provider__?: string;
  __tenant_config__?: Partial<ClientConfig>;
};

// This header is added to responses in the ingress layer so it needs to be resolved in FE
export default (async () => {
  if (isStandalone()) return;
  try {
    const providerRes = await fetch('/provider');
    const provider = providerRes?.headers.get('x-clubspark-root-provider-id');
    (window as CustomWindow).__provider__ = provider;

    const configRes = await fetch(
      `/config?filters[organisationId]=${provider}&populate[siteConfig][on][site-config.tournament-desk][populate]=*`,
    );
    const json = await configRes.json();
    const config = json?.data?.[0]?.attributes?.siteConfig?.[0];
    (window as CustomWindow).__tenant_config__ = config;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error((e as Error)?.message);
  }
})();

export const getRootProviderId = () => (window as CustomWindow).__provider__;
export const getTenantConfig = () => (window as CustomWindow).__tenant_config__ ?? {};
